// Plantas físicas del tenant (UPG tiene 4: Sopó, Entrerríos, Facatativá, Chía).
// Mirror de la tabla `plantas` (migración 00002).
import { z } from 'zod';
export const plantaSchema = z.object({
    id: z.string().uuid(),
    tenant_id: z.string().uuid(),
    nombre: z.string().trim().min(1).max(120),
    codigo: z.string().trim().min(1).max(40),
    direccion: z.string().nullable(),
    latitud: z.number().min(-90).max(90).nullable(),
    longitud: z.number().min(-180).max(180).nullable(),
    activa: z.boolean(),
});
//# sourceMappingURL=planta.js.map